import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
const StyledSplitButtonMenuToggle = styled('button', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: sizes.splitButton.menuToggleWidth,
    minWidth: sizes.splitButton.menuToggleWidth,
    height: sizes.button.smallHeight,
    padding: 0,
    border: 'none',
    backgroundColor: staticColors.buttonLightActionBackground,
    cursor: 'pointer',
    ':hover': {
        opacity: 0.8,
    },
});
export const SplitButtonMenuToggle = ({ testId, children, ...restProps }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(StyledSplitButtonMenuToggle, { ...restProps, ...testIdAttribute, children: children }));
};
